import React, { useEffect } from "react";
import Link from "helpers/link";
import loadScript from "helpers/load-script";

const StoreReviews = ({ data, className }) => {
    useEffect(() => {
        // Variable needed for script below, has to be global
        window.sa_review_count = data?.number || 5;
        loadScript("https://www.shopperapproved.com/merchant/15622.js"); 
    }, []);

    return (
        <div className="store-reviews container">
            <div
                style={{ backgroundColor: data?.color || "#fff" }}
                id="shopper_review_page"
                className={`${className} mt-10`}
            >

                <h2 className="mb-4 text-blue-700 font-normal">Reviews</h2>

                <div id="review_header" />
                <div id="merchant_page" />
                <div id="review_image">
                    <Link
                        aria-label="Go To Shopper Approved"
                        to="https://www.shopperapproved.com/reviews/sealskincovers.com/"
                        target="_blank"
                        rel="nofollow noreferrer"
                    />
                </div>
            </div>
        </div>
    );
};

export default StoreReviews;
